/* eslint-disable */
import {BaseInterfApi} from 'unityrpcjs/unityrpc.js'


export class RetMsg {
    constructor() {
        this.ret = 0;  // 0 require
        this.msg = "";  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

RetMsg.__json_class__ = 'Comm.RetMsg'

export class PageIn {
    constructor() {
        this.offset = 0;  // 0 require
        this.limit = 0;  // 1 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

PageIn.__json_class__ = 'Comm.PageIn'

export class PageOut {
    constructor() {
        this.total = 0;  // 0 require
    }

    dump() {
        return JSON.stringify(this);
    }
}

PageOut.__json_class__ = 'Comm.PageOut'


// WEBPACK FOOTER //
// ./src/apis/rpc/Comm/Comm.js